import { createAsyncThunk } from "@reduxjs/toolkit";

import externalUtilityv1 from "../../services/external-utilityv1";
import externalAxios  from '../../services/external-utility';


const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchDashboardData",

  async ({yearId, dashboardRegionType, dashboardRegionCode}) => {
    const response = await externalUtilityv1.post(`summarised-stats/public`,{
      yearId:yearId,
      regionType:dashboardRegionType,
      regionCode:dashboardRegionCode
    });
    return response.data;
  }
);

const fetchSchoolStatsData = createAsyncThunk(
  "dashboard/fetchSchoolStatsData",

  async ({yearId, dType, dCode,valueType }) => {
    console.log('--------------------')
    console.log('yearId', yearId)
    console.log('dType', dType)
    console.log('dCode', dCode)
    console.log('valueType', valueType)
    const response = await externalUtilityv1.post(`schools-summarised-stats/public`,{
      yearId:yearId,
      regionType:dType,
      regionCode:dCode,
      valueType :valueType

    });
    console.log('API calling-> schools-summarised-stats', response.data)
    return response.data;
  }
);

const fetchSchoolProfileStatsData = createAsyncThunk(
  "dashboard/fetchSchoolProfileData",

  async ({ dType, dCode,valueType, itemGroupId, itemId, yearId }) => {
    const response = await externalAxios.post(`profile-details/public`,{
      regionType:dType,
      regionCode:dCode,
      valueType :valueType,
      itemGroupId : itemGroupId,
      itemId : itemId,
      yearId : yearId
    });
    //console.log('response', response)
    return response.data;
  }
);

const fetchSchoolStatsDataYear = createAsyncThunk(
  "dashboard/fetchSchoolStatsDataYear",

  async ({ dType, dCode,valueType }) => {
    const response = await externalUtilityv1.post(`schools-summarised-stats/public`,{
      regionType:dType,
      regionCode:dCode,
      valueType :valueType

    });
    console.log('schools-summarised-stats', response.data)
    return response.data;
  }
);

const fetchSchoolProfileDataYear = createAsyncThunk(
  "dashboard/fetchSchoolProfileDataYear",

  async ({ dType, dCode,valueType, itemGroupId, itemId, yearId }) => {
    const response = await externalAxios.post(`profile-details/public`,{
      regionType:dType,
      regionCode:dCode,
      valueType :valueType,
      itemGroupId : itemGroupId,
      itemId : itemId,
      yearId : yearId

    });
    //console.log('response', response)
    return response.data;
  }
);


const fetchSchoolStatsIntData = createAsyncThunk(
  "dashboard/fetchSchoolStatsIntData",

  async ({yearId, dType, dCode }) => {
    const response = await externalUtilityv1.post(`schools-summarised-stats/public`,{
      yearId:yearId,
      regionType:dType,
      regionCode:dCode,
      valueType:1
    });
    return response.data;
  }
);

const fetchTeachersStatsData = createAsyncThunk(
  "dashboard/fetchTeachersStatsData",

  async ({ yearId, dType, dCode, valueType, removeYearId = false }) => {
    // Construct the payload dynamically

    console.log('removeYearId', removeYearId)
    let payload = {
      regionType: dType,
      regionCode: dCode,
      valueType: valueType,
    };

    // Conditionally add yearId if removeYearId is false
    if (!removeYearId) {
      payload.yearId = yearId;
    }

    const response = await externalUtilityv1.post(
      `teachers-summarised-stats/public`,
      payload
    );
    return response.data;
  }
);

const fetchTeachersForCWSNComputerData = createAsyncThunk(
  "dashboard/fetchTeachersForCWSNComputerData",

  async ({yearId, dType, dCode,valueType }) => {
    const response = await externalUtilityv1.post(`kpi/teachers-training/public`,
    {
      yearId:yearId,
      regionType:dType,
      regionCode:dCode,
      valueType:valueType
    });
    console.log('response.data', response.data)
    return response.data;
  }
);

const fetchTeachersStatsIntData = createAsyncThunk(
  "dashboard/fetchTeachersStatsIntData",

  async ({yearId, dType, dCode }) => {
    const response = await externalUtilityv1.post(`teachers-summarised-stats/public`,
    {
      yearId:yearId,
      regionType:dType,
      regionCode:dCode,
      valueType:1
    });
    ////console.log('response.data', response.data)
    return response.data;
  }
);

const fetchStudentStatsData = createAsyncThunk(
  "dashboard/fetchStudentsStatsData",

  async ({yearId, dType, dCode, valueType, removeYearId = false  }) => {

    console.log('removeYearId', removeYearId)
    let payload = {
      regionType: dType,
      regionCode: dCode,
      valueType: valueType,
    };

    // Conditionally add yearId if removeYearId is false
    if (!removeYearId) {
      payload.yearId = yearId;
    }

    console.log('payload',payload)
    const response = await externalUtilityv1.post(`students-summarised-stats/public`,
      payload
    );
    return response.data;
  }
);

const fetchStudentGPIStatsData = createAsyncThunk(
  "dashboard/fetchStudentGPIStatsData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`kpi/indicators-three/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType,
        itemGroupId: 9
      }
    );
    ////console.log('response.data', response.data)
    return response.data;
  }
);

const fetchStudentStatsIntData = createAsyncThunk(
  "dashboard/fetchStudentStatsIntData",

  async ({yearId, dType, dCode }) => {
    const response = await externalUtilityv1.post(`students-summarised-stats/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :1
      }
    );
    return response.data;
  }
);

const fetchMaptatsData = createAsyncThunk(
  "dashboard/fetchMaptatsData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`students-summarised-stats/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType
      }
    );
    //console.log('responseData-Mappppppp',  response.data)
    return response.data;
  }
);


const fetchMapSchoolsStatsData = createAsyncThunk(
  "dashboard/fetchMapSchoolsStatsData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`schools-summarised-stats/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType
      }
    );
    ////console.log('responseData',  response.data)
    return response.data;
  }
);

const fetchMapTeacherStatsData = createAsyncThunk(
  "dashboard/fetchMapTeacherStatsData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`teachers-summarised-stats/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType
      }
    );
    ////console.log('responseData',  response.data)
    return response.data;
  }
);

const fetchMapTeacherTrainedStatsData = createAsyncThunk(
  "dashboard/fetchMapTeacherTrainedStatsData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`kpi/teachers-training/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType
      }
    );
    ////console.log('fetchMapTeacherTrainedStatsData',  response.data)
    return response.data;
  }
);

const fetchMapStudentsStatsData = createAsyncThunk(
  "dashboard/fetchMapStudentsStatsData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`students-summarised-stats/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType
      }
    );
    //console.log('fetchMapStudentsStatsData',  response.data)
    return response.data;
  }
);


const fetchMapStudentsGPIStatsData = createAsyncThunk(
  "dashboard/fetchMapStudentsGPIStatsData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`kpi/indicators-three/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType,
        itemGroupId : 9
      }
    );
    //console.log('fetchMapStudentsGPIStatsData',  response.data)
    return response.data;
  }
);


const fetchMaptatsOtherData = createAsyncThunk(
  "dashboard/fetchMaptatsOtherData",

  async ({yearId, dType, dCode, valueType }) => {
    const response = await externalUtilityv1.post(`summarised-stats/public`,
      {
        yearId:yearId,
        regionType:dType,
        regionCode:dCode,
        valueType :valueType
      }
    );
    // console.log('response.data', response.data)
    return response.data;
  }
);




const fetchAllStateSchemesData = createAsyncThunk(
  "dashboard/fetchAllStateSchemesData",

  async ({yearId, regionType, dCode}) => {
    const response = await externalUtilityv1.post(`students-summarised-stats/public`,
      {
        yearId:yearId,
        regionType:regionType,
        regionCode:dCode
      }
    );
    return response.data;
  }
);


export  {fetchDashboardData,fetchSchoolStatsData,fetchSchoolProfileStatsData,fetchSchoolStatsDataYear, fetchSchoolProfileDataYear,fetchTeachersStatsData,fetchTeachersForCWSNComputerData,fetchMapTeacherStatsData,fetchStudentStatsData,fetchAllStateSchemesData,fetchSchoolStatsIntData,fetchStudentStatsIntData,fetchTeachersStatsIntData,fetchMaptatsData,fetchMapSchoolsStatsData,fetchMapStudentsStatsData,fetchMaptatsOtherData, fetchMapTeacherTrainedStatsData, fetchMapStudentsGPIStatsData, fetchStudentGPIStatsData};